export class MonitorWorkOrdersRequest {
  ConveyanceIDs?: number[];
  From?: Date;
  Until?: Date;
  OrderBySlowest: boolean;
  OrderByRecent: boolean;
  Limit: number;
  SearchTerm?: string;
}
